import { useContext } from 'react';

import { LoggerOverlayContext } from './loggerOverlay.provider';
import { LoggerOverlayContextProps } from './loggerOverlay.types';

export const useLoggerOverlay = (): LoggerOverlayContextProps => {
	const ctx = useContext(LoggerOverlayContext);
	if (ctx === undefined) {
		throw new Error('useLoggerOverlay used outside of LoggerOverlayProvider');
	} else {
		return ctx;
	}
};
